<form [formGroup]="form" class="mt-2">
  <ng-container [formArrayName]="formSectionName">
    <ng-container *ngFor="let guest of guestsArray; let index = index">
      <rx-applications-guest-search
        [index]="index"
        [multipleGuests]="guestsArray.length > 1"
        [formSectionName]="formSectionName"
      />
    </ng-container>
  </ng-container>
</form>
